<template>
  <Header />
  <div class="bg-gradient-to-b from-red-50 to-white min-h-screen">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto text-center mb-12">
        <h1 class="text-4xl md:text-5xl font-extrabold mb-6 text-gray-900">Present Planner Blog</h1>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">Discover gift ideas, inspiration, and strategies to make your gift-giving thoughtful, organized, and stress-free.</p>
      </div>
      
      <!-- Featured Post -->
      <div class="mb-16 max-w-5xl mx-auto">
        <div class="bg-white rounded-xl shadow-xl overflow-hidden">
          <div class="md:flex">
            <div class="md:w-2/5 relative">
              <img :src="featuredPost.image" :alt="featuredPost.title" class="h-full w-full object-cover">
              <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent md:hidden"></div>
            </div>
            <div class="md:w-3/5 p-6 md:p-8 flex flex-col justify-between">
              <div>
                <div class="uppercase tracking-wide text-xs font-semibold text-blue-600 mb-2">Featured Article</div>
                <h2 class="text-2xl md:text-3xl font-bold mb-4 text-gray-900">{{ featuredPost.title }}</h2>
                <p class="text-gray-600 mb-6 line-clamp-3">{{ featuredPost.excerpt }}</p>
              </div>
              <router-link :to="featuredPost.path" class="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors">
                Read the full article
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Blog Post Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="(post, index) in blogPostsExceptFeatured" :key="index" class="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-[1.02]">
          <router-link :to="post.path" class="block h-full">
            <div class="relative">
              <img :src="post.image" :alt="post.title" class="w-full h-48 object-cover">
              <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div class="p-6">
              <h2 class="text-xl font-bold mb-3 text-gray-900">{{ post.title }}</h2>
              <p class="text-gray-600 mb-4 line-clamp-3">{{ post.excerpt }}</p>
              <span class="inline-flex items-center text-blue-600 font-medium">
                Read more
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
            </div>
          </router-link>
        </div>
      </div>
      
      <!-- Email Signup
      <div class="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-xl overflow-hidden">
        <div class="p-8 md:p-10 text-center md:text-left md:flex items-center justify-between">
          <div class="md:w-2/3 mb-6 md:mb-0">
            <h3 class="text-2xl font-bold text-white mb-3">Stay Updated with Gift Ideas</h3>
            <p class="text-blue-100 max-w-xl">Get the latest gift inspiration, holiday guides, and organization tips delivered directly to your inbox.</p>
          </div>
          <div class="md:w-1/3 flex flex-col sm:flex-row md:flex-col gap-3">
            <input type="email" placeholder="Your email address" class="px-4 py-3 rounded-lg w-full text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300">
            <button class="bg-white text-blue-700 hover:bg-blue-50 font-medium px-4 py-3 rounded-lg transition-colors">Subscribe</button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "BlogView",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      blogPosts: [
        // {
        //   title: "Holiday Gift Guide 2023",
        //   path: "/blog/holiday-gift-guide",
        //   excerpt: "Discover the perfect gifts for everyone on your list this holiday season. From tech enthusiasts to home chefs, we've got you covered with creative and thoughtful ideas.",
        //   image: require("@/assets/blog/generic.png")
        // },
        {
          title: "Birthday Gift Ideas for All Ages",
          path: "/blog/birthday-gift-ideas",
          excerpt: "Find the perfect birthday gift for any age group with our comprehensive guide. We break down gift ideas by age categories from children to older adults.",
          image: require("@/assets/blog/birthday.png")
        },
        {
          title: "Budget-Friendly Gift Ideas",
          path: "/blog/budget-friendly-gifts",
          excerpt: "Amazing gift ideas that won't break the bank but will still impress. Learn how to give thoughtful presents without spending a fortune.",
          image: require("@/assets/blog/budget.png")
        },
        // {
        //   title: "Personalized Gift Ideas",
        //   path: "/blog/personalized-gifts",
        //   excerpt: "Discover how to create thoughtful personalized gifts for your loved ones. Make your presents more meaningful with custom touches.",
        //   image: require("@/assets/blog/generic.png")
        // },
        {
          title: "Last-Minute Gift Ideas",
          path: "/blog/last-minute-gifts",
          excerpt: "Quick gift solutions when time is running out but you still want to impress. Find perfect presents even when you're short on time.",
          image: require("@/assets/blog/last-minute.png")
        },
        {
          title: "Wedding Gift Guide",
          path: "/blog/wedding-gifts",
          excerpt: "The ultimate guide to finding the perfect wedding gift for any couple. Navigate wedding registries, cash gifts, and creative alternatives.",
          image: require("@/assets/blog/wedding.png")
        },
        {
          title: "Anniversary Gift Ideas by Year",
          path: "/blog/anniversary-gifts",
          excerpt: "Traditional and modern gift ideas for every wedding anniversary milestone. Find the perfect symbolic present for each year of marriage.",
          image: require("@/assets/blog/anniversary.png")
        },
        {
          title: "Gifts for Hard-to-Buy-For People",
          path: "/blog/gifts-for-difficult-people",
          excerpt: "Creative gift ideas for those people who seem to have everything already. Find unique presents for the most challenging recipients on your list.",
          image: require("@/assets/blog/hardtobuyfor.png")
        },
        {
          title: "Sustainable and Eco-Friendly Gift Ideas",
          path: "/blog/eco-friendly-gifts",
          excerpt: "Environmentally conscious gift options that show you care about the planet. Discover presents that are both thoughtful and sustainable.",
          image: require("@/assets/blog/eco.png")
        },
        // {
        //   title: "How to Use Present Planner Effectively",
        //   path: "/blog/present-planner-guide",
        //   excerpt: "Get the most out of Present Planner with our comprehensive user guide. Learn how to organize gifts, set reminders, and never miss an important date.",
        //   image: require("@/assets/blog/generic.png")
        // }
      ]
    };
  },
  computed: {
    featuredPost() {
      return this.blogPosts[0]; // Birthday Gift Ideas as featured post
    },
    blogPostsExceptFeatured() {
      return this.blogPosts.slice(1);
    }
  },
  metaInfo() {
    return {
      title: 'Present Planner Blog - Gift Ideas & Inspiration',
      meta: [
        { name: 'description', content: 'Browse gift ideas, inspiration and guides for all occasions including birthdays, holidays, anniversaries and more.' }
      ]
    };
  }
};
</script>

<style>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
</style> 